export const lineMixins = {
  data () {
    return {
      tempValues: {}
    }
  },
  methods: {
    // TODO: Deprecated
    getFieldWidth (fieldName) {
      switch (fieldName) {
        case 'description':
          return this.entityType !== 'ar' ? '20%' : '15%'
        case 'line_number':
        case 'asset':
          return '2.5%'
      }
      return this.entityType !== 'ar' ? '7.27%' : (this.$route.params.id ? '5.8%' : '6.27%')
    },
    handleLocalInputChange (fieldName, value, toTriggerEvent = false) {
      this.tempValues[fieldName] = value
      clearTimeout(this._inputTimer)
      this._inputTimer = setTimeout(() => {
        if (toTriggerEvent) this.handleInput(fieldName, value)
      }, 300)
    },
    handleLocalInputBlur (fieldName, e) {
      const val = this.tempValues[fieldName]
      this.line[fieldName] = val     // commit only once
      this.handleBlurEvent(e) // optional handler
    }
  }
}
